import { Navigate } from 'react-router';
import { Button, Card, ErrorState } from '@mgdlead/ui';

import { RouteLoading } from '../auth/guards';
import { useWorkspaces } from '../lib/api';
import { signOut } from '../lib/auth';
import { humanizeError } from '../lib/errors';

/**
 * `/` — decide para onde a pessoa vai.
 *
 * Com sessão e sem workspace o destino é o onboarding, não um painel vazio:
 * painel sem workspace não tem o que mostrar e só gera dúvida.
 */
export function RootRedirect() {
  const workspacesQuery = useWorkspaces();

  if (workspacesQuery.isPending) return <RouteLoading />;

  if (workspacesQuery.isError) {
    return (
      <div className="min-h-dvh bg-background p-4">
        <Card className="mx-auto mt-16 max-w-md">
          <ErrorState
            title="Não conseguimos carregar sua conta"
            description={humanizeError(workspacesQuery.error)}
            onRetry={() => void workspacesQuery.refetch()}
          />
          <div className="mt-2 flex justify-center">
            <Button variant="ghost" onClick={() => void signOut()}>
              Sair da conta
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  const first = workspacesQuery.data?.[0];
  if (!first) return <Navigate to="/onboarding" replace />;

  return <Navigate to={`/w/${first.slug}`} replace />;
}
